import React from 'react';
import Tooltip from '@shared/components/tooltips/workflow-tooltip';
import { ColorConstants } from '@shared/constants';
import { IconQuestionMark } from '@paretogroup/tess';
import * as S from './accordion-label.styles';


interface Props {
    label: string,
    iconPath?: string,
    textInfo?: string,
    top?: number,
    left?: number,
}

export const AccordionLabelWithTooltip = ({
    label,
    textInfo,
    top = 25,
    left = 5,
}: Partial<Props> = {}) => (
    <Tooltip
        text={textInfo}
        top={top}
        left={left}
        placement="right"
        verticalAlignment="bottom"
        stylesToolTip={S.StylesToolTip}
    >
        <S.WrapperIcon>
            <S.LabelIcon>{label}</S.LabelIcon>
            <IconQuestionMark
                size={16}
                primaryColor={ColorConstants.tower_gray}
                secondaryColor={ColorConstants.white}
            />
        </S.WrapperIcon>
    </Tooltip>
);
